export const DesignerSettingsItem = ({
  title,
  rightItem,
  children,
}: {
  title: string;
  rightItem?: React.ReactNode;
  children?: React.ReactNode;
}) => (
  <div className="flex-col gap-150">
    <div className="flex-row h-600 items-center justify-between gap-150">
      <div className="label-md-semibold text-primary">{title}</div>
      {rightItem}
    </div>
    {children}
  </div>
);
